'use strict';

class ReportFormInvoice {
  constructor($scope, $location, reportService, productService, Notification) {
    this.$scope = $scope;
    this.$location = $location;
    this.reportService = reportService;
    this.productService = productService;
    this.Notification = Notification;
  }

  $onInit() {
    this.attachments = [];
    this.results = {};
    this.columns = [];
    this.selectedColumns = [];
    this.params = {
      columns: [],
      from: moment().startOf('month').format('DD.MM.YY'),
      to: moment().endOf('month').format('DD.MM.YY'),
      format: 'JSON',
      productCode: this.$location.search().produkt || null,
      paid: 'null'
    };
    this.toggleColumns = false;
    this.toggleAttachments = false;
    this.format = 'XLS';

    $('#productCode').autocomplete({
      minLength: 1,
      source: (req, resp) => {
        this.productService.list(req.term)
          .then((products) => {
            let suggestions = [];

            $.each(products.data.items, (i, val) => {
              suggestions.push({
                value: val.code,
                label: `${val.code} - ${val.description}`,
                number: val.code
              });
            });

            resp(suggestions);
          });
      },
      select: (e, ui) => {
        if (ui.item.number) {
          this.params.productCode = ui.item.number;
        }
      }
    });

    this.$scope.$watchCollection('$ctrl.params', () => {
      // optional params for exporting
      if (this.params.productCode !== null && this.params.productCode !== '') {
        if (this.params.paid !== 'null') {
          this.productParams = {
            productCode: this.params.productCode,
            paid: this.params.paid
          };
        } else {
          this.productParams = {
            productCode: this.params.productCode
          };
        }
      } else {
        this.productParams = {};
      }
    });

    this.loadColumns();
  }

  checkType(val) {
    return this.reportService.checkType(val);
  }

  preview() {
    if (this.params.columns.length) {
      let params = {
        columns: this.params.columns.join(','),
        from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
        to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD'),
        format: 'JSON'
      };

      if (this.params.productCode !== null) {
        params.productCode = this.params.productCode;
      }

      if (this.params.paid && this.params.paid !== 'null') {
        params.paid = this.params.paid;
      }

      this.reportService.generate('invoices', params)
        .then((resp) => {
          if (resp.status === 204) {
            this.results = [];
            this.Notification.info('Det var ingen fakturaer i valgt periode.');
          } else {
            this.results = resp.data;
          }
        });
    }
  }

  loadColumns() {
    this.columns = [];

    this.reportService.availableColumns('invoices')
      .then((resp) => {
        this.columns = resp.data;
        this.results = {};

        // preselect
        resp.data.forEach((c) => {
          if (c.preselected) {
            this.selectColumn(c.key);
          }
        }, this);
      });
  }

  selectColumn(key) {
    if ($.inArray(key, this.selectedColumns) === -1) {
      this.selectedColumns.push(key);
    } else {
      let index = this.selectedColumns.indexOf(key);
      this.selectedColumns.splice(index, 1);
    }

    angular.extend(this.params, {
      columns: this.selectedColumns
    });
  }

  toggle(state) {
    if (state) {
      this.selectedColumns = [];
    }

    this.columns.forEach((col) => {
      this.selectColumn(col.key);
      col.preselected = state;
    }, this);
  }

  getAttachments() {
    if (this.toggleAttachments) {
      this.toggleAttachments = false;
      return;
    }
    let params = {};

    if (this.type === 'invoiceNumber' && this.invoice.from !== null && this.invoice.to !== null) {
      angular.extend(params, {
        invoiceNumberFrom: this.invoice.from,
        invoiceNumberTo: this.invoice.to
      });
    } else {
      angular.extend(params, {
        columns: this.params.columns.join(','),
        from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
        to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD')
      });
    }

    this.reportService.getAttachments(params)
      .then((resp) => {
      this.attachments = resp.data;
  });
    this.toggleAttachments = true;
  }

  download(format, email = false) {
    let params = {
      format: format,
      columns: this.selectedColumns.join(','),
      from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
      to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD')
    };

    if (email) {
      params.email = this.email;
    }

    if (!angular.equals({}, this.productParams)) {
      angular.extend(params, this.productParams);
    }

    this.reportService.download('invoices', params, email)
      .then((resp) => {
        if (resp) {
          this.Notification.success(`Rapporten er sendt til ${this.email}`);
        }
      });
  }
}

ReportFormInvoice.$inject = ['$scope', '$location', 'reportService', 'productService', 'Notification'];

const reportFormInvoice = {
  bindings: {
    email: '<'
  },
  controller: ReportFormInvoice,
  template: `
    <h2>Fakturajournal</h2>

    <div report-generator ng-model="$ctrl.params"></div>

    <div class="row">
      <div class="large-6 columns">
        <fieldset>
          <label for="format">Format</label>
          <select id="format" ng-model="$ctrl.format">
            <option value="CSV">CSV</option>
            <option value="XLS">Excel</option>
            <option value="PDF">PDF</option>
          </select>
        </fieldset>

        <fieldset>
          <label for="productCode">Produktnummer</label>
          <input id="productCode" type="text" ng-model="$ctrl.params.productCode">

          <select id="paid" ng-model="$ctrl.params.paid" ng-show="$ctrl.params.productCode">
            <option value="null">alle</option>
            <option value="true">betalt</option>
            <option value="false">ubetalt</option>
          </select>
        </fieldset>
      </div>

      <div class="large-6 columns">
        <fieldset>
          <label for="email">E-postadresse</label>
          <input id="email" name="email" type="email" ng-model="$ctrl.email">
        </fieldset>
      </div>
    </div>

    <p><a href ng-click="$ctrl.toggleColumns = !$ctrl.toggleColumns">Velg kolonner (viser {{ $ctrl.selectedColumns.length }} av {{ $ctrl.columns.length }})</a></p>

    <fieldset ng-show="$ctrl.toggleColumns">
      <p>
        <a href ng-if="$ctrl.selectedColumns.length < $ctrl.columns.length" ng-click="$ctrl.toggle(true)">Velg alle</a>
        <a href ng-if="$ctrl.selectedColumns.length === $ctrl.columns.length" ng-click="$ctrl.toggle(false)">Skjul alle</a>
      </p>

      <div class="row">
        <div ng-repeat="column in $ctrl.columns track by $index" class="large-6 columns">
          <label for="column_{{ $index }}">
            <input id="column_{{ $index }}" type="checkbox" ng-value="column.key" ng-click="$ctrl.selectColumn(column.key)" ng-checked="column.preselected"> {{ column.name }}
          </label>
        </div>
      </div>
    </fieldset>

    <button ng-click="$ctrl.preview()" class="button">Vis</button>

    <div ng-show="$ctrl.results.items.length">
      <a href ng-click="$ctrl.download($ctrl.format)" class="button secondary"><i class="fa fa-file-o"></i> Last ned</a>

      <a ng-show="$ctrl.email" href ng-click="$ctrl.download($ctrl.format, true)" class="button secondary"><i class="fa fa-envelope-o"></i> Send på e-post</a>

      <a href ng-click="$ctrl.getAttachments()"> Vis vedlegg</a>
      
      <fieldset ng-show="$ctrl.toggleAttachments">

        <p ng-show="$ctrl.attachments.length == 0">Det er ingen vedlegg i den valgte perioden</p>
        <div ng-show="$ctrl.attachments.length > 0">
          <table>
            <thead>
              <tr>
                <th>Fakturanummer</th>
                <th>Vedlegg</th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="attachment in $ctrl.attachments">
                <td>
                  <a ng-if="!attachment.credit" target="_blank" href="#/regning/{{ attachment.invoiceNo }}">{{ attachment.invoiceNo }}</a>
                  <a ng-if="attachment.credit" target="_blank" href="#/kreditnota/{{ attachment.invoiceNo }}">{{ attachment.invoiceNo }}</a>
                </td>
                <td>
                  <a href="{{ attachment.cloudUrl }}">
                    <i class="fa fa-file-o"></i>
                    {{ attachment.originalFilename }}
                  </a>
                  </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--<div>-->
          <!--<b>Vedlegg:</b>-->
          <!--<ul style="list-style: none; margin-top: 10px;">-->
            <!--<li ng-repeat="attachment in $ctrl.attachments">-->
              <!--<a href="{{ attachment.cloudUrl }}">-->
                <!--<i class="fa fa-file-o"></i>-->
                <!--{{ attachment.originalFilename }}-->
              <!--</a>-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      </fieldset>

      
      <table class="responsive">
        <thead>
          <tr>
            <th ng-repeat="(key, value) in $ctrl.results.headers" ng-bind="value"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.results.items track by $index">
            <td class="nowrap" ng-repeat="(key, value) in item" ng-if="key !== '_links'">
              <a href="#/regning/{{ value }}" ng-if="key === 'invoiceNumber'">{{ value }}</a>
              <span ng-if="key !== 'invoiceNumber'" ng-bind="$ctrl.checkType(value, key)"></span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr ng-repeat="item in $ctrl.results.items | limitTo:1 track by $index">
            <th class="nowrap" ng-repeat="(key, value) in item" ng-bind="$ctrl.checkType($ctrl.results.summary[key])" ng-if="key !== '_links'"></th>
          </tr>
        </tfoot>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('reportFormInvoice', reportFormInvoice)
  .config(($routeProvider) => {
    $routeProvider
      .when('/rapport/fakturajournal', {
        title: 'Fakturajournal',
        template: '<report-form-invoice email="$resolve.email" />',
        secure: true,
        resolve: {
          email: (originatorService) => originatorService.get().then((resp) => resp.data.contact.email)
        }
      });
  });
